import React from 'react';
import PropTypes from 'prop-types';

const Star = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M3.9592 18.8469L10 0.234695L16.0408 18.8469L0.204102 7.33674H19.7959" fill={color} />
  </svg>
);

Star.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Star;
